<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 9/9/2021
  -->

<template>
	<div>
		<div v-if="!recurringBillingItem.isEnabled">
			<RecurringBillingDataPicker v-model="recurringBillingItem" ref="recurringBillingDataPicker"/>
<!--			<RecurringBillingDataPicker-->
<!--				:value="recurringBillingItem"-->
<!--				@input="value => $emit('update:recurringBillingItem', value)"-->
<!--				ref="recurringBillingDataPicker"/>-->

		</div>

		<div v-else>
			<div class="row mx-0 align-items-center">
				<div class="col px-0" >
					<FormRow title="Charge: ">
						<span v-if="recurringBillingItem.hasSetupFee">
						{{ currencyFormatted(recurringBillingItem.setupFeeAmount + recurringBillingItem.recurringAmount)}} one time <ToolTipView >{{ currencyFormatted(recurringBillingItem.setupFeeAmount) }} one time fee + {{currencyFormatted(recurringBillingItem.recurringAmount)}} initial subscription fee of the first {{recurringBillingItem.recurringInterval}}</ToolTipView> <br/>then
						</span>
						{{ currencyFormatted(recurringBillingItem.recurringAmount) }} every
						{{ recurringBillingItem.recurringIntervalCount }}
						{{ recurringBillingItem.recurringInterval }}

						<br/>
					</FormRow>
				</div>
				<div>
					<qw-button type="circle" icon="icon-pencil" @click="onEditBillingDataClicked()"/>
				</div>
			</div>

			<div v-if="recurringBillingItem.isEnabled && isStripeIntegrated && !isProgramTemplate">
				<FormRow
					title="Status:">
					<SubscriptionStatusView :recurringBillingItem="recurringBillingItem"/>
				</FormRow>

				<FormRow
					v-if="recurringBillingItem.isActive()"
					title="Next charge:">
					{{recurringBillingItem.nextChargeFormatted()}}
				</FormRow>
			</div>

		</div>


		<div class="text-center mt-5" v-if="isStripeIntegrated && !recurringBillingItem.isActive()">
			<div v-if="recurringBillingItem.isEnabled" class="row mx-0 align-items-center">
				<div>Recurring billing enabled
				</div>
				<div class="layout-spacer"/>

				<qw-button type="default" plain @click="onDeactivateSubscription">
					Disable
					<ToolTipView>
						Disabling recurring billing will allow your clients to access this program despite of their
						subscription status.
					</ToolTipView>
				</qw-button>

			</div>
			<div v-else>
				<qw-button type="primary" plain @click="onActivateSubscription">
					Enable recurring billing
					<ToolTipView>
						Enable recurring billing to charge your clients a subscription fee.
						<br/><br/>
						Your client will be presented with a consent screen to opt in for a subscription with you.
						<br/><br/>
						The consent scree will also collect their credit card information. Once they opt in, they'll
						get access to the coaching materials.
					</ToolTipView>
				</qw-button>
			</div>

		</div>
		<div v-show="!isStripeIntegrated">
			<hr v-if="!hidePaymentMethodsView"/>
			<PaymentMethodsManageView
				v-show="!hidePaymentMethodsView"
				:modal="modal"
				allowedIntegrations="STRIPE"
				:modalSize="modalSize"
				:analytics-props="analyticsPropsMethod()"
				@paymentIntegrationsLoaded="onPaymentIntegrationsLoaded"
			/>
		</div>
		<div v-if="isStripeIntegrated && recurringBillingItem.isActive()">
			<qw-button plain class="w-100 my-3" @click="onSubscriptionCancelClicked">Cancel subscription</qw-button>
		</div>
		<LoadingIndicator/>
	</div>

</template>

<script>

import BasePaymentTypePanel from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/BasePaymentTypePanel.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import PaymentMethodsManageView from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentMethodsManageView.vue";
let EditBillingDataDialog = () => import("@/core/modules/coach/Coaching/Panels/ProgramBilling/Dialogs/EditBillingDataDialog.vue");
import {createDialogLazy} from "@/utils/helpers-external";
import RecurringBillingDataPicker from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/RecurringBillingDataPicker.vue";
import {classToClass} from "@qwoach/class-transformer-wrapper";
import SubscriptionStatusView
	from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/SubscriptionStatusView.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import SubscriptionStatusEnum from "@shared/Billing/SubscriptionStatusEnum";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";

let editBillingDataDialog = createDialogLazy(EditBillingDataDialog)

export default {
	name: "RecurringPaymentTypePanel",
	components: {
		LoadingIndicator,
		SubscriptionStatusView, RecurringBillingDataPicker, PaymentMethodsManageView, ToolTipView, FormRow},
	extends: BasePaymentTypePanel,

	data() {
		return {
			isStripeIntegrated: false
		}
	},

	created() {
		this.setup()
	},

	methods: {

		async setup(){
			// let paymentIntegrations = await this.handleAsync(this.$dataManager.getPaymentIntegrationsMain())
			// if(paymentIntegrations){
			// 	this.onPaymentIntegrationsLoaded(paymentIntegrations)
			// }
		},

		onPaymentIntegrationsLoaded(paymentIntegrations) {
			this.isStripeIntegrated = paymentIntegrations.isStripeIntegrated()
		},


		async onDeactivateSubscription() {
			await this.handleAsync(async () => {
				if(!this.isProgramTemplate){
					await this.cancelSubscription()
				}

				this.recurringBillingItem.isEnabled = false
				await this.$dataManager.setProgram({
					id: this.programItem.id,
					recurringBillingItem: {
						isEnabled: false
					}
				})
			})
			// this.toast("Subscription was disable successfully")
		},

		async validate(){
			if(this.$refs.recurringBillingDataPicker){
				return await this.$refs.recurringBillingDataPicker.validateForm()
			}
			return true

		},

		async onActivateSubscription() {
			let res = await this.validate()
			console.log("onActivateSubscription: isFormValid = ", res)
			if (res) {
				this.recurringBillingItem.isEnabled = true
				this.recurringBillingItem.subscriptionStatus = SubscriptionStatusEnum.NOT_SET

				await this.handleAsync(this.$dataManager.updateProgram(this.programItem))
				// this.toast("Subscription was enabled successfully")
			}
		},

		async onSubscriptionCancelClicked(){
			let res = await yesNoDialog({
				title: "Cancel this subscription?",
				description: "If you cancel this subscription, your client won't be charged moving forward. <br/><br/>They will still have access to their coaching portal till the end of the current billing cycle.",
				yesTitle: "Proceed",
				noTitle: "Back"
			})

			if(res){
				res = await this.handleAsync(this.cancelSubscription())
				if(res){
					this.recurringBillingItem.subscriptionStatus = SubscriptionStatusEnum.CANCELED
				}
			}

		},

		async cancelSubscription(){
			await this.$dataManager.apiPostStripeCancelSubscription({coachId: this.ownerProfile.id, subscriptionId: this.recurringBillingItem.stripeSubscriptionId})
			return true
		},

		async onEditBillingDataClicked() {
			let dataCopy = classToClass(this.recurringBillingItem)
			await editBillingDataDialog({
				recurringBillingItem: dataCopy,
				onBeforeOk: async () => {
					let res = true;
					if(this.recurringBillingItem.isActive()){
						res = await yesNoDialog({
							title: "Update billing data?",
							description: "Depending on the changes you've made it may result in additional charges for your client. <br/><br/>The price will be prorated accordingly before proceeding.",
							yesTitle: "Save"
						})
					}
					return res
				},
				onOk: async data => {
					console.log("onEditBillingDataClicked onOk data = ", data)
					if(this.isProgramTemplate){
						this.recurringBillingItem = data
						await this.$dataManager.updateProgram(this.programItem)
					} else {
						let recurringBillingItem = await this.$dataManager.apiPostStripeUpdateRecurringPricing({
							programId: this.programItem.id,
							recurringBillingItem: data
						})
						console.log("onEditBillingDataClicked onOk data from server = ", recurringBillingItem)
						this.recurringBillingItem = recurringBillingItem
					}
				}
			})
		},


	},

	computed: {
		recurringBillingItem: {
			cache: false,
			get: function () {
				return this.programItem.recurringBillingItem
			},
			set: function (newVal) {
				this.programItem.recurringBillingItem = newVal
			}
		},
	},


}
</script>

<style lang="scss">

</style>
